import type { FC } from 'react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, ToggleButton, Typography } from '@mui/material';

import ChatbotFeedbackForm from 'src/components/chatbot/ChatbotChat/components/FeedbackForm';

import { styles } from './index.styles';

export interface ChatbotChatProps {
  scrollToBottom: () => void;
}

const ChatbotFeedbackButton: FC<ChatbotChatProps> = ({ scrollToBottom }) => {
  const { t } = useTranslation('chatbot');

  const [showForm, setShowForm] = useState<boolean>(false);
  const [successfulFormSubmission, setSuccessfulFormSubmission] =
    useState<boolean>(false);
  const [failedFormSubmission, setFailedFormSubmission] =
    useState<boolean>(false);

  useEffect(() => {
    scrollToBottom();
  }, [showForm]);

  const handleOnTryAgainClick = (_e: any) => {
    setFailedFormSubmission(false);
    setShowForm(true);
  };

  const handleFailedFormSubmission = (_e: any) => {
    setFailedFormSubmission(true);
    setShowForm(false);
  };

  return (
    <>
      <Box>
        {successfulFormSubmission && (
          <Box>
            <Typography variant="caption" sx={styles.feedbackSuccess}>
              {t('ChatbotFeedback.FeedbackSuccess')}
            </Typography>
          </Box>
        )}
        {!successfulFormSubmission && failedFormSubmission && (
          <Box sx={styles.feedbackError}>
            <Typography>{t('ChatbotFeedback.FeedbackError')}</Typography>
            <Box sx={styles.feedbackErrorButtonBox}>
              <Button
                sx={styles.feedbackErrorButton}
                onClick={handleOnTryAgainClick}
              >
                {t('ChatbotFeedback.TryAgain')}
              </Button>
            </Box>
          </Box>
        )}
        {!successfulFormSubmission && !failedFormSubmission && (
          <ToggleButton
            value=""
            sx={styles.feedbackToggle}
            onChange={() => setShowForm((prevState) => !prevState)}
          >
            {t('ChatbotFeedback.FeedbackToggle')}
          </ToggleButton>
        )}
      </Box>
      {showForm && !successfulFormSubmission && (
        <ChatbotFeedbackForm
          onCancelButtonClick={() => setShowForm(false)}
          setSubmitSuccessful={setSuccessfulFormSubmission}
          setSubmitFailed={handleFailedFormSubmission}
        />
      )}
    </>
  );
};

export default ChatbotFeedbackButton;
